export enum TicketFeeType {
  FREE = 'FREE',
  PAID = 'PAID',
}
